export interface ThemeColorsType {
  'main': string;
  'dark': string;
  'darker': string;
  'blank': string;
  'background': string;
  'backgroundDark': string;
  'success': string;
  'yellow': string;
  'warning': string;
  'error': string;
  'ultraViolet': string;
  'ultraGreen': string;
  'teal': string;
  'red': string;
  'orange': string;
  'green': string;
  'lighterGreen': string;
  'yellowPalette': string;
  'deepBlue': string;
  'paleBlue': string;
  'disabled': string;
  'amountNegative': string;
  'amountPositive': string;
  'childRowBackground': string;
  'cellText': string;
  'rowSelected': string; // nuevo token para fila seleccionada
}

interface ThemeLightColorsType {
  'success': string;
  'warning': string;
  'error': string;
  'ultraViolet': string;
  'ultraGreen': string;
}

interface ThemePaletteColorsType {
  'chartGreen': {
    400: string;
  };
}

interface ThemeShadesColorsType {
  neutral: string[]
}

export interface ThemeType {
  colors: {
    main: ThemeColorsType;
    light: ThemeLightColorsType;
    palette: ThemePaletteColorsType;
    shades: ThemeShadesColorsType;
  };
  font: {
    family: string[];
    size: {
      [key: string]: string;
    };
  };
  size: {
    headerHeight: string;
    footerHeight: string;
  };
  breakpoints: {
    1130: string;
    1200: string;
    1550: string;
  }
}

const theme: ThemeType = {
  'colors': {
    'main': {
      'main': '#0B2355',
      'dark': '#0B1026',
      'darker': '#151B34',
      'blank': '#ffffff',
      'background': '#ffffff',
      'backgroundDark': '#151B34',
      'success': '#74bf33',
      'yellow': '#fff000',
      'warning': '#ffb833',
      'error': '#d23333',
      'ultraViolet': '#9435fb',
      'ultraGreen': '#3dfcb0',
      'rowSelected': '#9AF095',
      'teal': '#31B297',
      'red': '#C1392D',
      'orange': '#E77E22',
      'green': '#00993A',
      'lighterGreen': '#00993a80',
      'yellowPalette': '#FFB833',
      'deepBlue': '#1C39D8',
      'paleBlue': '#E5E9FF',
      'disabled': '#CCCCCC',
      'amountNegative': '#C1392D',
      'amountPositive': '#00993A',
      'childRowBackground': '#F1F1F1',
      'cellText': '#35323F'
    },
    'light': {
      'success': '#badf99',
      'warning': '#ffdc99',
      'error': '#e99999',
      'ultraViolet': '#ca9afd',
      'ultraGreen': '#9efed8'

    },
    'palette': {
      'chartGreen': {
        400: '#00B345',
      },
    },
    'shades': {
      'neutral': ['#f0f1f5',
        '#d2d6e0',
        '#b4bbcb',
        '#96a0b6',
        '#7885a1',
        '#5e6c87',
        '#495469',
        '#343c4b',
        '#1f242d',
        '#0a0c0f',
        '#CCCCCC',
        '#C1C1C1',
        '#6b6b6b',
        '#e9e9ef',
        '#DAD9E2',
        '#d2d6e0'
      ]
    }
  },
  'font': {
    'family': ['"aktiv-grotesk", Arial, Helvetica, sans-serif', '"miller-display", Georgia, Times, "Times New Roman", serif'],
    'size': {
      'h1': '44px',
      'h2': '26px',
      'h3': '22px',
      'h4': '16px',
      'h5': '14px',
      'h6': '12px',
      'p': '14px',
      'smallest': '10px'
    }
  },
  size: {
    headerHeight: '98px',
    footerHeight: '224px'
  },
  breakpoints: {
    1130: '1130px',
    1200: '1200px',
    1550: '1550px'
  }
}

export const themeColors: ThemeColorsType = theme.colors.main

export type ThemeColorsKeysType = keyof typeof themeColors;

export const themeColorsLight: ThemeLightColorsType = theme.colors.light

export type ThemeColorsLightKeysType = keyof typeof themeColorsLight;

export type ThemeColorsShadesNeutral = 'neutral-0' | 'neutral-1' | 'neutral-2' | 'neutral-3' | 'neutral-4' | 'neutral-5' | 'neutral-6' | 'neutral-7' | 'neutral-8' | 'neutral-9';

export default theme
